export class ShipmentCOD {
  reference: string

  value: number

  currency: string

  codId: number

  constructor(reference: string, value: number, currency: string, codId: number) {
    this.reference = reference
    this.value = value
    this.currency = currency
    this.codId = codId
  }
}
